<template>
  <div class="w-full h-full" ref="selectRef">
    <button :disabled="disabled" class="grm-cams-select-container w-full h-full" :class="css" @click="onToggleOpen">
      <div class="selected-name">{{ getName }}</div>
      <div class="icon-select-button"></div>
    </button>
    <GrmCamstudyOptionModal
        v-if="isOpenOptions && isMobile"
        @onCloseOption="onCloseSelect"
        @onNextAct="onSaveSelect"
        :list="list"
        :position="position"
        :name="name"
        :value="value"
        :title="title"
    />
    <div v-else-if="!isMobile">
      <div v-show="isOpenOptions" class="desktop-modal" v-click-outside="onCloseSelect" ref="mobile-modal" :class="{ 'open-upward': shouldOpenUpward }">
        <div v-for="(item, idx) in list" :key="idx" class="modal-item" @click="() => onSaveSelect(item.value)">{{item.name}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import GrmCamstudyOptionModal from "@/components/Common/camstudyOptionModal/GrmCamstudyOptionModal.vue";
import {Device} from "@/utils"

export default {
  name: 'GrmCamstudySelect',
  components: {GrmCamstudyOptionModal},
  emits: ['update:value'],
  props: {
    position: {
      type: Object,
      default: () => {
        return {
          bottom: '72px',
          left: '8px',
        }
      },
    },
    name: {
      type: String,
      default: '',
    },
    css: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    title: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  data(){
    return {
      isOpenOptions: false,
      shouldOpenUpward: false
    }
  },
  mounted() {
    if(!this.isMobile){
      const width = this.$refs.selectRef.clientWidth || 80;
      this.$refs['mobile-modal'].style.width = width + 'px'
    }
  },
  watch: {
    isOpenOptions(val){
      if (!this.isMobile && val) {
        this.$nextTick(() => {
          const selectEl = this.$refs.selectRef;
          const modalEl = this.$refs['mobile-modal'];
          const rect = selectEl.getBoundingClientRect();
          const windowHeight = window.innerHeight;

          const spaceBelow = windowHeight - rect.bottom;
          const modalHeight = modalEl.offsetHeight || 150;

          this.shouldOpenUpward = spaceBelow < modalHeight;
        });
      }
    }
  },
  computed: {
    getName(){
      return this.list.find((item) => item.value == this.value)?.name || ''
    },
    isMobile(){
      return Device.isMobile()
    }
  },
  methods: {
    onToggleOpen(){
      this.isOpenOptions = !this.isOpenOptions;
    },
    onCloseSelect(){
      this.isOpenOptions = false;
    },
    onSaveSelect(data){
      this.$emit('update:value', data);
      this.onChange(data);
      this.onCloseSelect();
    },
    onChange(data){
      this.$emit('onChange', data);
    },
  }
}
</script>

<style scoped lang="scss">
.grm-cams-select-container{
  display: flex;
  min-height: 32px;
  padding: 0 12px;
  justify-content: space-between;
  align-items: center;
  color: #FFF;
  font-size: 14px;
  background: #393939;
  line-height: 1.5;

  &:disabled{
  }

  .icon-select-button{
    width: 0;
    height: 0;
    border-left: 3px solid transparent;
    border-right: 3px solid transparent;
    border-top: 4px solid white;
    margin-left: 10px;
    // background: url('~@/assets/images/camstudy/ico_triangle_down_white.png') center center no-repeat;
  }
  .selected-name{
    width: 100%;
    text-align: left;
    text-wrap: nowrap;
    overflow: hidden;
  }
}
.desktop-modal{
  padding: 8px 0;
  border-radius: 6px;
  background: #393939;
  transform: translateY(7.5px);
  position: absolute;
  z-index: 999;
  &.open-upward {
    transform: translateY(calc(-40.5px + -100%));
  }
  .modal-item{
    height: 36px;
    padding: 8px 12px;
    color: #FFF;
    font-size: 14px;
    text-wrap: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>